var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0893 2.41083C10.7639 2.08539 10.2363 2.08539 9.91083 2.41083L6.57749 5.74416C6.25206 6.0696 6.25206 6.59723 6.57749 6.92267C6.90293 7.24811 7.43057 7.24811 7.756 6.92267L9.66675 5.01193V14.6667C9.66675 15.127 10.0398 15.5001 10.5001 15.5001C10.9603 15.5001 11.3334 15.127 11.3334 14.6667V5.01193L13.2442 6.92267C13.5696 7.24811 14.0972 7.24811 14.4227 6.92267C14.7481 6.59723 14.7481 6.0696 14.4227 5.74416L11.0893 2.41083Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83341 15.0834C3.83341 14.6232 3.46032 14.2501 3.00008 14.2501C2.53984 14.2501 2.16675 14.6232 2.16675 15.0834V16.3334C2.16675 18.1744 3.65913 19.6667 5.50008 19.6667H15.5001C17.341 19.6667 18.8334 18.1744 18.8334 16.3334V15.0834C18.8334 14.6232 18.4603 14.2501 18.0001 14.2501C17.5398 14.2501 17.1667 14.6232 17.1667 15.0834V16.3334C17.1667 17.2539 16.4206 18.0001 15.5001 18.0001H5.50008C4.57961 18.0001 3.83341 17.2539 3.83341 16.3334V15.0834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.5720662124a6e4f18eed5aae7bb426df.svg";
export { ForwardRef as ReactComponent };